const AGENT_SCOUT_PATH = '/agent_scout';
const AGENT_SCOUT_GATEWAY_PREFIX = '/bigolive_agent_misc';

/**
 * YApi 和 Mock 场景继续使用原始路径，真实网关统一补充服务前缀。
 */
export const resolveGatewayRequestPath = (path: string, currentEnv: string) => {
  if (
    currentEnv !== 'mock' &&
    (path === AGENT_SCOUT_PATH || path.startsWith(`${AGENT_SCOUT_PATH}/`))
  ) {
    return `${AGENT_SCOUT_GATEWAY_PREFIX}${path}`;
  }

  return path;
};
